"use client";

import { useState } from "react";
import { cn } from "@marketing-sites/utils/cn";

interface ScoreInputProps {
  value: number | null;
  onChange: (value: number | null) => void;
  label?: string;
  muted?: boolean;
}

export function ScoreInput({
  value,
  onChange,
  label = "Your score",
  muted = false,
}: ScoreInputProps) {
  const [focused, setFocused] = useState(false);

  return (
    <span className="inline-flex items-baseline">
      <input
        type="number"
        inputMode="decimal"
        min={0}
        max={100}
        step="any"
        placeholder={focused ? "" : "0"}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        onWheel={(e) => e.currentTarget.blur()}
        value={value ?? ""}
        onChange={(e) => {
          const raw = e.target.value;
          onChange(raw === "" ? null : Math.min(100, Math.max(0, Number(raw))));
        }}
        aria-label={label}
        className={cn(
          "border-current/40 w-[3.5ch] border-b bg-transparent text-center outline-none [font-family:inherit] [font-size:inherit] [font-weight:inherit] focus:border-current [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none",
          muted && "text-current/60",
        )}
      />
      <span>%</span>
    </span>
  );
}
